<template>
  <div class="images-manager" :class="[isModal === true ? 'is-modal' : '']">
    <div class="images-manager__content">
      <div class="images-manager__content__header">
        <h1>{{ selectedTab }}</h1>
        <div class="images-manager__content__header__button-container">
          <div class="button-container">
            <button
              class="button-neutral"
              @click="showApproveModalForMultiple = true"
              :disabled="activeSelectionIdList.length == 0"
            >
              DELETE SELECTED
            </button>
            <button class="button-positive" @click="onShowUploadMediaModal">
              UPLOAD
            </button>
          </div>

          <div
            class="close-modal-button"
            v-if="isModal === true"
            @click="$emit('close')"
          >
            <img src="@/assets/EndOfLife/closeIconDark.svg" alt="Close Icon" />
          </div>
        </div>
      </div>
      <div class="tabbar">
        <div class="tabs">
          <h2
            class="h3"
            v-for="tab in tabs"
            :key="tab"
            :class="[tab === selectedTab ? 'active-tab' : '']"
          >
            {{ tab }}
          </h2>
        </div>
        <div class="sorting">
          <p>Sort by:</p>
          <select
            name="sort-by"
            id="sort-by"
            v-model="selectedSortOption"
            @change="sortImages(selectedSortOption)"
          >
            <option v-for="option in sortOptions" :value="option" :key="option">
              {{ option }}
            </option>
          </select>
        </div>
      </div>
      <div class="images-container" v-if="!this.collectionOfImageObjects">
        <h2>You haven't uploaded any images yet</h2>
        <p>Click the UPLOAD button to get going with your media library</p>
      </div>
      <div
        v-else
        class="images-container"
        :class="[showPreview ? 'column-four' : 'column-six']"
      >
        <div
          class="wrapper"
          v-for="(imageObject,
          key,
          index) in collectionOfImageObjectsWithThumbnailUrls"
          :key="key"
        >
          <div
            class="single-wrap"
            :class="{'single-wrap--loading': imageObject.uploading}"
            v-on:click="onOpenPreview(imageObject, key, index)"
          >
            <div class="loader__spin" v-if="imageObject.uploading"></div>
            <img :src="imageObject.url" :alt="imageObject.name" v-else/>
          </div>
          <div @change="multipleSelectionAdd(key, imageObject.imagename)">
            <label class="container">
              <input type="checkbox" />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="buttonColumn">
      <div class="buttonWrap">
        <button-global
          text="CANCEL"
          type="neutral"
          @eventPassed="cancelTheSelection"
          v-if="multipleDeleteSelection"
        ></button-global>
        <button-global
          text="DELETE MORE"
          type="negative"
          @eventPassed="activeMultipleSelection"
          v-if="activeSelectionList.length === 0"
        ></button-global>
        <button-global
          text="DELETE MARKED"
          type="negative"
          @eventPassed="showApproveModalForMultiple = true"
          v-else
        ></button-global>
        <button-global
          text="UPLOAD"
          type="positive"
          @eventPassed="showUploadModal = true"
          :disabled="multipleDeleteSelection"
        ></button-global>
      </div>
    </div> -->

    <div class="static-preview-container" :style="{ width: previewWidth }">
      <div class="preview-container" v-if="showPreview">
        <div class="preview-container__header">
          <div
            class="preview-container__header__wrapper"
            @click="onClosePreview"
          >
            <img src="@/assets/EndOfLife/closeIconDark.svg" alt="Close Icon" />
          </div>
          <h2>Preview</h2>
          <div class="preview-container__header__wrapper"></div>
        </div>
        <div class="preview-container__image-wrapper">
          <div class="loader__spin" v-show="isLoadingPreviewImage"></div>
          <img
            v-show="!isLoadingPreviewImage"
            :src="selectedPreviewUrl"
            class="previewImage"
            @load="isLoadingPreviewImage = false"
          />
        </div>
        <div class="preview-container__details-wrapper">
          <div class="preview-container__details-wrapper__details">
            <table>
              <tr>
                <th colspan="2">Image Details</th>
              </tr>
              <tr>
                <td>File Name:</td>
                <td>{{ selectedImageText }}</td>
              </tr>
              <tr>
                <td>Uploaded:</td>
                <td>{{ selectedTimestamp }}</td>
              </tr>
              <!-- Also for future update <tr>
                <td>Category:</td>
                <td>Change category here</td>
              </tr> -->
            </table>
          </div>
          <div class="preview-container__details-wrapper__button-container">
            <ButtonGlobal
              type="negative"
              text="DELETE"
              @eventPassed="showApproveModal = true"
            />
            <ButtonGlobal
              type="positive"
              text="SELECT"
              @eventPassed="emitUrl"
              v-if="isModal"
            />
          </div>
        </div>
      </div>
    </div>
    <approve-modal
      @yes.once="deleteImage()"
      @no="onCancelDeleteModal()"
      v-if="showApproveModal"
    >
      <p slot="text">Are you sure you want to delete the selected images?</p>
    </approve-modal>
    <approve-modal
      @yes.once="deleteMultipleImages()"
      @no="onCancelDeleteMultipleModal()"
      v-if="showApproveModalForMultiple"
    >
      <p slot="text">Are you sure to delete these images?</p>
    </approve-modal>
    <!-- <approve-modal
      @yes="deleteMutipleImages()"
      @no="doNotDeleteMutipleImages()"
      v-if="showApproveModalForMultiple"
    >
      <p slot="text">
        Are you sure to delete {{ activeSelectionList.length }} images?
      </p>
    </approve-modal> -->
    <transition name="fadeInModal">
      <UploadMediaModal
        v-if="showUploadModal"
        @changed="onUpload"
        @close="onCloseUploadMediaModal"
      />
    </transition>
  </div>
</template>
<script>
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import ApproveModal from "@/components/GlobalComponents/ApproveModal";
import UploadMediaModal from "./UploadMediaModal";

import { db, storage } from "@/firebase.js";

export default {
  name: "ImagesManager",
  components: {
    ButtonGlobal,
    ApproveModal,
    UploadMediaModal,
  },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      previewWidth: "0px",

      // backdropActive: false,
      selectedSortOption: "Newest",
      showPreview: false,
      selectedId: "",
      selectedPreviewUrl: "",
      selectedMobileUrl: "",
      selectedIndex: -1,
      selectedFullName: "",
      selectedImageText: "",
      selectedTimestamp: "",
      showApproveModal: false,
      showUploadModal: false,
      showApproveModalForMultiple: false,

      multipleDeleteSelection: false,
      activeSelectionIdList: [],
      activeSelectionNameList: [],

      collectionOfImageObjects: {},
      collectionOfImageObjectsWithThumbnailUrls: {},
      selectedTab: "All images",
      tabs: ["All images"], // "Icons", "Images", "Other"],
      sortOptions: ["Oldest", "Newest"], //, "Type"]
      isLoadingPreviewImage: false,
    };
  },
  computed: {
    previewImages() {
      // Drop the reference between previewImagesObject and this.collectionOfImageObjects
      let previewImagesObject = this.dropReference(
        this.collectionOfImageObjects
      );

      for (let imageObject in previewImagesObject) {
        previewImagesObject[imageObject].url = this.convertTypeOfImageUrl(
          imageObject.url,
          "%2Fdesktop%2Fdesktop-1000_"
        );
      }

      return previewImagesObject;
    },
  },
  created() {
    this.renderUpdated();
  },
  methods: {
    /*
      Render methods
    */

    renderUpdated() {
      db.ref(`images/${this.$customerId}/${this.$hotelId}`).on("value", (snapshot) => {
        this.collectionOfImageObjects = snapshot.val();
        this.renderConvertedToThumbnailUrl(snapshot.val());
      });
    },
    renderConvertedToThumbnailUrl(objectOfImages) {
      let temporaryObjectOfImages = this.dropReference(objectOfImages);

      // Pick thumbnail images
      for (let imageKey in temporaryObjectOfImages) {
        temporaryObjectOfImages[imageKey].url = this.convertTypeOfImageUrl(
          temporaryObjectOfImages[imageKey].url,
          "%2Fthumbnail%2Fthumbnail-200_"
        );
      }

      // Update collecion of image objects for use in the image list
      this.collectionOfImageObjectsWithThumbnailUrls = temporaryObjectOfImages;
      this.sortImages(this.selectedSortOption);
    },

    /*
      Event actions/triggers
    */

    onShowUploadMediaModal() {
      this.showUploadModal = true;
    },
    onCloseUploadMediaModal() {
      this.showUploadModal = false;
    },
    onOpenPreview(imageObject, imageKey, imageIndex) {
      if (imageObject.uploading) {
        return;
      }
      if (this.selectedIndex !== imageIndex) {
        this.isLoadingPreviewImage = true;
      }

      this.selectedFullName = imageObject.imagename;
      this.backdropActive = true;
      this.setPreviewWidth();
      this.showPreview = true;
      this.selectedId = imageKey;
      this.selectedPreviewUrl = this.convertTypeOfImageUrl(
        imageObject.url,
        "%2Fdesktop%2Fdesktop-1000_"
      );
      this.selectedIndex = imageIndex;
      this.selectedImageText = imageObject.imageText;
      this.selectedTimestamp = imageObject.timestamp
        ? `${new Date(imageObject.timestamp).getDate()}/${
            new Date(imageObject.timestamp).getMonth() + 1
          }/${new Date(imageObject.timestamp).getFullYear()}`
        : "Date unavailable";
    },
    onClosePreview() {
      this.backdropActive = false;
      this.removePreviewWidth();
      this.showPreview = false;
      this.selectedFullName = "";
    },
    onUpload(newObjectOfImages) {
      this.collectionOfImageObjects = newObjectOfImages;
      this.renderConvertedToThumbnailUrl(this.collectionOfImageObjects);
    },
    onCancelDeleteModal() {
      this.showApproveModal = false;
    },

    /*
      Utility functions
    */
    dropReference(object) {
      return JSON.parse(JSON.stringify(object));
    },
    setPreviewWidth() {
      this.previewWidth = "500px";
    },
    removePreviewWidth() {
      this.previewWidth = "0px";
    },
    convertTypeOfImageUrl(url, targetType) {
      if (!url) {
        return;
      }
      const hotelId = encodeURIComponent(this.$hotelId);

      let newUrl = this.dropReference(url);
      let oldUrl = this.dropReference(url);

      if (url.includes("%2Fdesktop%2Fdesktop-1000_")) {
        newUrl = oldUrl.replace(
          hotelId + "%2Fdesktop%2Fdesktop-1000_",
          hotelId + targetType
        );
      } else if (url.includes("%2Fthumbnail%2Fthumbnail-200_")) {
        newUrl = oldUrl.replace(
          hotelId + "%2Fthumbnail%2Fthumbnail-200_",
          hotelId + targetType
        );
      } else {
        newUrl = oldUrl.replace(hotelId + "%2F", hotelId + targetType);
      }
      return newUrl;
    },
    emitMobileUrl() {
      this.selectedMobileUrl = this.selectedPreviewUrl.replace(
        encodeURIComponent(this.$hotelId) + "%2Fdesktop%2Fdesktop-1000_",
        encodeURIComponent(this.$hotelId) + "%2Foriginal%2Foriginal-null_"
      );
      this.$emit("changed", this.selectedMobileUrl);
      this.$emit("close");
    },
    emitUrl() {
      if (this.isMobile) {
        this.selectedMobileUrl = this.selectedPreviewUrl.replace(
          encodeURIComponent(this.$hotelId) + "%2Fdesktop%2Fdesktop-1000_",
          encodeURIComponent(this.$hotelId) + "%2Foriginal%2Foriginal-null_"
        );
        this.$emit("changed", this.selectedMobileUrl);
      } else {
        this.$emit("changed", this.selectedPreviewUrl);
      }
      this.$emit("close");
    },
    sortImages(sortBy) {
      let list = this.collectionOfImageObjectsWithThumbnailUrls;

      if (!list) {
        return;
      }

      let callbackRule;
      if (sortBy == "Newest") {
        callbackRule = (a, b) =>
          list[b].timestamp ? list[b].timestamp - list[a].timestamp : -1;
      } else if (sortBy == "Oldest") {
        callbackRule = (a, b) =>
          list[a].timestamp ? list[a].timestamp - list[b].timestamp : -1;
      }

      let newThing = new Object();
      list = Object.keys(list)
        .sort(callbackRule)
        .map((elem) => ({
          [elem]: list[elem],
        }))
        .forEach((v) => {
          Object.assign(newThing, v);
        });

      this.collectionOfImageObjectsWithThumbnailUrls = newThing;
    },
    deleteImage() {
      db.ref(`images/${this.$customerId}/${this.$hotelId}`)
        .child(this.selectedId)
        .remove()
        .then(() => {
          let imageRefToStorage = storage.ref(this.$hotelId);
          //const deleteDesktop =
          imageRefToStorage
            .child("desktop")
            .child("desktop-1000_" + this.selectedFullName)
            .delete();
          //const deleteMobile =
          imageRefToStorage
            .child("mobile")
            .child("mobile-375_" + this.selectedFullName)
            .delete();
          //const deleteThumbnails =
          imageRefToStorage
            .child("thumbnail")
            .child("thumbnail-200_" + this.selectedFullName)
            .delete();
          // Promise.all([deleteDesktop, deleteMobile, deleteThumbnails])
          //   .then(() => {
          this.showApproveModal = false;
          this.backdropActive = false;
          this.removePreviewWidth();

          // Rerender the object list of which the thumbnails get appended from.
          //this.renderConvertedToThumbnailUrl(this.collectionOfImageObjects);

          delete this.collectionOfImageObjects[this.selectedId];
          this.$toastEvents.push({
            type: "copy",
            title: "Deletion",
            content: "The image has been removed",
            id: +new Date(),
          });
          this.showPreview = false;
          this.selectedId = "";
          this.selectedPreviewUrl = "";
          this.selectedIndex = -1;
          this.selectedFullName = "";
          //    })
          //  .catch(error => {
          // console.log(error);
          // this.showApproveModal = false;
          // this.backdropActive = false;
          // delete this.collectionOfImageObjects[this.selectedId];

          // this.removePreviewWidth();
          // this.renderConvertedToThumbnailUrl(this.collectionOfImageObjects);
          // this.showPreview = false;
          // this.selectedId = "";
          // this.selectedIndex = -1;
          // this.selectedPreviewUrl = "";
          // this.selectedFullName = "";
          //        });
        });
    },

    // Commented out for now, as new design don't include this function yet
    multipleSelectionAdd(selectedId, selectedImagename) {
      // if it already has image, remove it from the list
      if (this.activeSelectionIdList.includes(selectedId)) {
        let index = this.activeSelectionIdList.indexOf(selectedId);

        this.activeSelectionIdList.splice(index, 1);
        this.activeSelectionNameList.splice(index, 1);
      } else {
        // else add it to the list
        this.activeSelectionIdList.push(selectedId);
        this.activeSelectionNameList.push(selectedImagename);
      }
    },
    activeMultipleSelection() {
      this.multipleDeleteSelection = true;
    },
    onCancelDeleteMultipleModal() {
      this.showApproveModalForMultiple = false;
    },
    deleteMultipleImages() {
      let imageRefToStorage = storage.ref(this.$hotelId);
      this.showApproveModalForMultiple = false;
      this.showProcessingLoader = true;

      for (var i = 0; i < this.activeSelectionIdList.length; i++) {
        let imageId = this.activeSelectionIdList[i];
        let imageFullName = this.activeSelectionNameList[i];

        db.ref(`images/${this.$customerId}/${this.$hotelId}`)
          .child(imageId)
          .remove()
          .then(() => {
            let deleteDesktop = imageRefToStorage
              .child("desktop")
              .child("desktop-1000_" + imageFullName)
              .delete();
            let deleteMobile = imageRefToStorage
              .child("mobile")
              .child("mobile-375_" + imageFullName)
              .delete();
            let deleteThumbnails = imageRefToStorage
              .child("thumbnail")
              .child("thumbnail-200_" + imageFullName)
              .delete();
            return Promise.all([deleteDesktop, deleteMobile, deleteThumbnails]);
          });

        // Delete the deleted image from list
        delete this.collectionOfImageObjects[imageId];
      }

      // Rerender the object list of which the thumbnails get appended from.
      this.renderConvertedToThumbnailUrl(this.collectionOfImageObjects);

      this.multipleDeleteSelection = false;
      this.activeSelectionIdList = [];
      this.activeSelectionNameList = [];
      this.showProcessingLoader = false;
      //bus.$emit('rerenderComp');
      this.$toastEvents.push({
        type: "copy",
        title: "Deletion",
        content: "The images has been removed",
        id: +new Date(),
      });
    },
    cancelTheSelection() {
      this.multipleDeleteSelection = false;
      this.activeSelectionIdList = [];
      this.activeSelectionNameList = [];
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.is-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}
.images-manager {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  background-color: #f7f7f7;
}
.images-manager__content {
  width: 100%;
  padding: 30px;
  overflow-y: scroll;
}
.images-manager__content::-webkit-scrollbar {
  display: none;
}
.images-manager__content__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.images-manager__content__header h1 {
  margin: 0;
}
.images-manager__content__header__button-container {
  display: flex;
  align-items: center;
}
.images-manager__content__header__button-container .close-modal-button {
  width: 30px;
  height: 30px;
  margin-left: 30px;
  cursor: pointer;
}
.images-manager__content__header__button-container .close-modal-button img {
  width: 30px;
  height: 30px;
}
.tabbar {
  display: flex;
  justify-content: space-between;
  height: 50px;
  background-color: white;
  margin-bottom: 30px;
  border-radius: 4px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
}
.tabbar h2 {
  display: inline-block;
  font-weight: normal;
  font-size: 18px; /* Block height 20px, perfect for padding and tabbar height */
  padding: 15px;
  margin: 0;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.5);
}
.tabbar h2:hover,
.tabbar h2.active-tab {
  color: black;
}
.sorting {
  margin-right: 15px;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.5);
}
.sorting p {
  margin: 0;
  padding: 15px 5px;
}
#sort-by {
  border: none;
  padding-bottom: 1px;
  cursor: pointer;
}
#sort-by option {
  color: rgba(0, 0, 0, 0.5);
}
.images-container {
  width: 100%;
  display: grid;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
}
.images-container.column-six {
  grid-template-columns: auto auto auto auto auto auto;
}
.images-container.column-four {
  grid-template-columns: auto auto auto auto;
}
.wrapper {
  position: relative;
}
.single-wrap {
  width: 100%;
  height: auto;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}
.single-wrap--loading {
  cursor: progress;
}
.single-wrap .loader__spin {
  margin: -56.25% -50px 0;
}
.single-wrap img {
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
}
.static-preview-container {
  /* width: 0; /* Always try to be as small as possible */
  background-color: white;
  box-shadow: -3px 0px 8px rgba(0, 0, 0, 0.25);
}
.preview-container {
  width: 100%;
  /* height: 100%; */
  padding: 30px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
.preview-container__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -5px; /* Cancel 5px of the padding */
  margin-bottom: 25px;
}
.preview-container__header__wrapper {
  width: 30px;
  height: 30px;
}
.preview-container__header__wrapper img {
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.preview-container__header h2 {
  font-size: 18px;
  margin: 0;
}
.preview-container__image-wrapper {
  background-color: rgba(0, 0, 0, 0.05);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  min-height: 250px;
}
.preview-container__image-wrapper img {
  width: auto;
  max-width: 100%;
  max-height: 250px;
}
.preview-container table {
  text-align: left;
  width: 100%;
  margin-bottom: 30px;
}
.preview-container table tr:nth-child(2) {
  background-color: rgba(0, 0, 0, 0.05);
}
.preview-container table tr td {
  font-size: 12px;
}
.preview-container table tr td:first-of-type {
  font-weight: bold;
  width: 100px;
}
.preview-container__details-wrapper__button-container {
  display: flex;
  justify-content: center;
}
.buttonWrap {
  position: fixed;
  bottom: 20px;
}
.buttonWrap > div {
  margin-top: 20px;
}

.container {
  position: absolute;
  top: 0px;
  right: 0px;
  padding-right: 32px;
  cursor: pointer;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 5px;
  height: 24px;
  width: 24px;
  border-radius: 8px;
  border-style: solid;
  border-color: var(--primary);
  box-shadow: var(--shadow);
  transition: var(--transition);
  background-color: #f3f3f3;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  border-color: var(--primary-hover);
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: var(--primary);
}

.container:hover input:checked ~ .checkmark {
  background-color: var(--primary-hover);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  opacity: 0;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  opacity: 1;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.loader__spin {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  animation: spin 1s cubic-bezier(0.15, 0.4, 0.6, 0.3) infinite;
  border: 8px solid #f2f2f2;
  border-top: 8px solid #48b9ba;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
